import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './Timeline.css';

interface TimelinePointProps {
    point: {
        label: string;
        subLabel?: string;
        formatted?: string | null;
        isActive: boolean;
    };
    duration: number | null;
    index: number;
    totalPoints: number;
    translationNamespace?: string;
}

function TimelinePoint({point, duration, index, totalPoints, translationNamespace = 'subscriptions'}: TimelinePointProps) {
    const {t} = useTranslation(translationNamespace);

    return (
        <>
            <css.pointWrapper>
                <css.point isActive={point.isActive} />
                <css.label isActive={point.isActive}>
                    {`${point.label}\n`}
                    {point.subLabel && `${point.subLabel}\n`}
                    {point.formatted && `${point.formatted}\n`}
                </css.label>
            </css.pointWrapper>
            {/* Duration badge between points */}
            {index < totalPoints - 1 && duration !== null && totalPoints > 1 && (
                <css.durationBadge>
                    {duration} {t('days')}
                </css.durationBadge>
            )}
        </>
    );
}

export default TimelinePoint;

